import React from "react";
const NotFoundPage = () => {
  return (
    <div>
      <h1>The page does not exist.</h1>
    </div>
  );
};

export default NotFoundPage;
